import { useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'
import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'

const bootGames = () => {
  const { cmsConfig } = useCmsConfigStore()
  const { setGameLinks } = useGamesStore()

  setGameLinks(cmsConfig?.games?.docs ?? [])
}

export { bootGames }
